<template>
    <div class="w-100">
        <div class="d-flex w-100">
            <div class="mr-4 w-100">
                <div class="d-flex w-100">
                    <v-text-field @input="setSearch" :value="search" append-icon="mdi-magnify"
                                  label="Rechercher par nom"
                                  clearable class="mb-4" outlined hide-details>
                    </v-text-field>

                    <v-select label="Catégorie" outlined chips small-chips deletable-chips :items="categories"
                              @input="setSelectedCategories" :value="selectedCategories" item-value="id"
                              item-text="label"
                              class="ml-4" multiple>
                    </v-select>

                    <v-select :label="cityWording" outlined chips small-chips deletable-chips :items="communes"
                              @input="setSelectedCommunes" :value="selectedCommunes" item-value="id" item-text="name"
                              class="ml-4" multiple>
                    </v-select>

                    <v-select label="Statut d'ouverture" outlined chips small-chips deletable-chips
                              :items="businessStatusAvailables"
                              @input="setSelectedBusinessStatus" :value="selectedBusinessStatus" item-value="code"
                              item-text="label"
                              class="ml-4" multiple>
                    </v-select>

                    <v-select label="Etat" outlined chips small-chips deletable-chips :items="providerStates"
                              @input="setSelectedProviderStates" :value="selectedProviderStates" item-value="code"
                              item-text="label"
                              class="mb-4 ml-4" multiple>
                    </v-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
    name: "VtcProvidersFilters",
    data() {
        return {
            loadingCommunes: false,
            searchCommunes: null,
            cityWording: "Commune",
            providerStates: [
                "Suivi",
                "A identifier",
                'Pas de source Google satisfaisante',
            ],
            businessStatusAvailables: [
                {
                    code: 'OPERATIONAL',
                    label: 'Actif'
                },
                {
                    code: 'CLOSED_TEMPORARILY',
                    label: 'Fermé temporairement'
                },
                {
                    code: 'CLOSED_PERMANENTLY',
                    label: 'Fermé définitivement'
                },
            ],
            communes: [],
            categories: [],
        }
    },
    methods: {
        ...mapMutations("vtcFilter", [
            "setSearch", "setSelectedCategories", "setSelectedCommunes",
            "setSelectedProviderStates", "setSelectedTags", "setSelectedTourismSectors", "setEmailSearch",
            'setSelectedBusinessStatus',
        ]),
        ...mapMutations("resource", ["setWebFormStates"]),
        setCommunesAndCategories() {
            this.communes = this.vtc.providers.map(pro => pro.commune).sort(this.orderByName)
            this.categories = this.vtc.providers.map(pro => pro.category).sort(this.orderByName)
        },
        orderByName(a, b) {
            if (a.name < b.name) {
                return -1
            }
            if (a.name > b.name) {
                return 1
            }
            return 0
        },
    },
    computed: {
        ...mapState("vtcFilter",
          ["search", "selectedCategories", "selectedProviderStates", "selectedTags", "selectedCommunes",
              "selectedTourismSectors", "emailSearch", 'selectedBusinessStatus',],
        ),
        ...mapState("account", ["tags", "account", "tourismSectors"]),
        ...mapState("vtc", [
            'vtc',
        ]),
    },
    watch: {
        vtc() {
            this.setCommunesAndCategories()
        }
    },
    created() {
        if (this.account.configurations.quebec) {
            this.cityWording = "Municipalité"
        }

        this.setCommunesAndCategories()

        this.$store.dispatch("account/fetchTags")
    },
}
</script>